import { ColumnMapping, ValidationError } from './types';

export const validateRequiredFields = (
  columnMapping: Record<string, ColumnMapping>,
  dataRows: any[][],
  requiredFields?: Array<{ key: string; type: string; label: string }>
): ValidationError[] => {
  const errors: ValidationError[] = [];

  const requiredColumns = Object.values(columnMapping).filter(mapping => mapping.header?.includes('*'));

  dataRows.forEach((row, rowIndex) => {
    requiredColumns.forEach(column => {
      const value = row[column.index];
      if (value === undefined || value === null || String(value).trim() === '') {
        errors.push({
          row: rowIndex + 2,
          field: column.key,
          message: `${column.header.replace('*', '')} không được để trống`,
          section: column.type,
          columnIndex: column.index
        });
      }
    });
  });

  if (requiredFields) {
    const fieldIndexMap = new Map<string, { index: number; type: string }>();
    Object.values(columnMapping).forEach(mapping => {
      const fieldKey = `${mapping.key}_${mapping.type}`;
      fieldIndexMap.set(fieldKey, { index: mapping.index, type: mapping.type });
    });

    dataRows.forEach((row, rowIndex) => {
      requiredFields.forEach(field => {
        const fieldKey = `${field.key}_${field.type}`;
        const mappingInfo = fieldIndexMap.get(fieldKey);

        if (mappingInfo !== undefined) {
          const value = row[mappingInfo.index];
          if (value === undefined || value === null || String(value).trim() === '') {
            const alreadyExists = errors.some(e => e.row === rowIndex + 2 && e.columnIndex === mappingInfo.index);
            if (!alreadyExists) {
              errors.push({
                row: rowIndex + 2,
                field: field.key,
                message: `${field.label} không được để trống`,
                section: mappingInfo.type,
                columnIndex: mappingInfo.index
              });
            }
          }
        }
      });
    });
  }

  return errors;
};

export const formatValidationErrors = (errors: ValidationError[]): string => {
  if (errors.length === 0) return '';

  const grouped = new Map<number, string[]>();
  errors.forEach(error => {
    const messages = grouped.get(error.row) || [];
    messages.push(`${error.field}: ${error.message}`);
    grouped.set(error.row, messages);
  });

  const lines: string[] = [];
  grouped.forEach((messages, row) => {
    lines.push(`Dòng ${row}: ${messages.join(', ')}`);
  });

  return lines.slice(0, 10).join('\n') + (lines.length > 10 ? `\n... và ${lines.length - 10} lỗi khác` : '');
};
